import React from 'react';
import Session from './Session';
import { Provider } from './CurrentUserContext';
import EnsureUser from './EnsureUser';

const CurrentUserProvider = ({ children }) => (
  <Session
    render={({ loading, authenticated }) =>
      authenticated ? (
        <EnsureUser render={({ user }) => (
          <Provider value={{ loading, user }}>
            {children}
          </Provider>
        )} />
      ) : (
          <React.Fragment>
            {children}
          </React.Fragment>
        )} />
);

export default CurrentUserProvider;



// WEBPACK FOOTER //
// ./src/components/CurrentUserProvider.js